import React, { useCallback } from 'react';

import { createEcommerceService, createModifyCartEvent, useTrackModifyCartEvent } from '../../../ecommerce';
import { useDeleteInsuranceAwaitable, usePostInsuranceAwaitable } from '../../../services';
import { CartActions, ECartActions, IToggleInsuranceAction } from '../model';

export const useToggleInsurance = (dispatch: React.Dispatch<CartActions>) => {
  const { request: deleteInsuranceRequest } = useDeleteInsuranceAwaitable();
  const { request: addInsuranceRequest } = usePostInsuranceAwaitable();
  const trackModifyCartEvent = useTrackModifyCartEvent();

  return useCallback(
    async (data: IToggleInsuranceAction) => {
      let insuranceData;

      if (data.active) {
        insuranceData = (await addInsuranceRequest())?.data;

        insuranceData &&
          trackModifyCartEvent({
            ...createModifyCartEvent(0, 1),
            product: createEcommerceService(insuranceData.serviceItems.insurance),
          });
      } else {
        insuranceData = (await deleteInsuranceRequest())?.data;

        insuranceData &&
          trackModifyCartEvent({
            ...createModifyCartEvent(1, 0),
            product: createEcommerceService(data.service!),
          });
      }

      if (insuranceData) {
        dispatch({
          actionType: ECartActions.TOGGLE_INSURANCE,
          payload: { pricesSummary: insuranceData.pricesSummary, insurance: insuranceData.serviceItems.insurance },
        });
      }
    },
    [dispatch, trackModifyCartEvent, addInsuranceRequest, deleteInsuranceRequest],
  );
};
